export default "__VITE_ASSET__9f528ee5__"